// extracted by mini-css-extract-plugin
export default {"content":"landing_content__alsPO","container":"landing_container__OOsXh","stats":"landing_stats__DSnhr","chart":"landing_chart__HlCla","play":"landing_play__MQUhc"};